
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4289|7551|9131)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
